// src/App.js
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';
import useAuthStore from './store/authStore';

import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import StudentsPage from './pages/StudentsPage';
import StudentProfilePage from './pages/StudentProfilePage';
import AddEditStudentPage from './pages/AddEditStudentPage';
import DevicesPage from './pages/DevicesPage';
import DeviceDetailPage from './pages/DeviceDetailPage';
import RadiusPage from './pages/RadiusPage';
import MLInsightsPage from './pages/MLInsightsPage';
import ReportsPage from './pages/ReportsPage';
import SettingsPage from './pages/SettingsPage';
import AdminsPage from './pages/AdminsPage';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, staleTime: 30_000 }
  }
});

function PrivateRoute({ children }) {
  const token = useAuthStore(s => s.token);
  return token ? children : <Navigate to="/login" replace />;
}

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Toaster position="top-right" toastOptions={{ duration: 3500 }} />
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard"            element={<DashboardPage />} />
            <Route path="students"             element={<StudentsPage />} />
            <Route path="students/new"         element={<AddEditStudentPage />} />
            <Route path="students/:id"         element={<StudentProfilePage />} />
            <Route path="students/:id/edit"    element={<AddEditStudentPage />} />
            <Route path="devices"              element={<DevicesPage />} />
            <Route path="devices/:id"          element={<DeviceDetailPage />} />
            <Route path="radius"               element={<RadiusPage />} />
            <Route path="ml"                   element={<MLInsightsPage />} />
            <Route path="reports"              element={<ReportsPage />} />
            <Route path="settings"             element={<SettingsPage />} />
            <Route path="admins"               element={<AdminsPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
